// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles-module--footer--1gbQI","bottomBlock":"styles-module--bottomBlock--lteW-"};